import { Modal, Select } from 'antd';

export type TableOption = {
  id: number;
  name: string;
};

export const moveTableOptions: TableOption[] = Array.from({ length: 20 }, (_, index) => ({
  id: index + 1,
  name: `Bàn ${index + 1}`,
}));

type ChuyenBanModalProps = {
  open: boolean;
  selectedTableName?: string;
  availableTables?: TableOption[];
  moveTargetId: number | null;
  confirmLoading?: boolean;
  onSelectTarget: (value: number) => void;
  onConfirm: () => void;
  onCancel: () => void;
};

export default function ChuyenBanModal({
  open,
  selectedTableName,
  availableTables = moveTableOptions,
  moveTargetId,
  confirmLoading = false,
  onSelectTarget,
  onConfirm,
  onCancel,
}: ChuyenBanModalProps) {
  const { Option } = Select;

  return (
    <Modal
      title={`Chuyển ${selectedTableName || 'bàn'} sang bàn khác`}
      open={open}
      onOk={onConfirm}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      okText="Xác nhận"
      cancelText="Hủy"
    >
      <Select
        style={{ width: '100%' }}
        value={moveTargetId ?? undefined}
        onChange={onSelectTarget}
        placeholder="Chọn bàn đích"
      >
        {availableTables.map((table) => (
          <Option key={table.id} value={table.id}>
            {table.name}
          </Option>
        ))}
      </Select>
    </Modal>
  );
}
